export function isActiveLevel(e){var r=e.currentBitrate,t=e.levelBitrate,a=e.levelVariant,i=e.currentVariant;return e.showLevelVariants?r===t&&i===a:r===t}